/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { ScriptRunnerComponentTypeEnum } from './scriptRunnerComponentTypeEnum';


export interface ScriptExecuteRequestDto { 
    /**
     * Unique identifier of the script to execute
     */
    script_id: string;
    target_cloud: CloudProviderEnum;
    service_type: ServiceTypeEnum;
    /**
     * Optional list of organization UUIDs for multi-org fleet execution; empty means all orgs
     */
    org_ids?: Array<string>;
    /**
     * Optional list of AWS regions for fleet execution; empty means all regions
     */
    regions?: Array<string>;
    /**
     * Optional list of script runner component types to target (e.g. IRR, CDVX)
     */
    component_types?: Array<ScriptRunnerComponentTypeEnum>;
    /**
     * Script-specific input parameters as key-value string pairs
     */
    parameters?: { [key: string]: string; };
}
export namespace ScriptExecuteRequestDto {
}


